import { render } from "./InitAnimation.vue?vue&type=template&id=59ff84bf&scoped=true"
const script = {}

import "./InitAnimation.vue?vue&type=style&index=0&id=59ff84bf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59ff84bf"

export default script